import React from "react";
import { Link } from "@tanstack/react-router";
import {
  CheckCircleOutlined,
  YoutubeOutlined,
} from "@ant-design/icons";

type AuthorizationPoint = {
  text: string;
};

const authorizationPoints: AuthorizationPoint[] = [
  {
    text: "Users explicitly authorize the connection through Google OAuth.",
  },
  {
    text: "All actions are performed on behalf of the authenticated, authorizing user.",
  },
  {
    text: "The application only accesses the YouTube account the user authorized.",
  },
  {
    text: "YouTube data is used solely to provide KGS Studio functionality.",
  },
  {
    text: "The application does not access unrelated YouTube accounts.",
  },
  {
    text: "Authorization can be revoked at any time from the Google Account permissions page.",
  },
];

const YoutubeIntegration = () => {
  return (
    <section
      id="youtube"
      className="border-t border-[#E5E7EB] bg-white px-5 py-16 sm:px-8 sm:py-20 lg:px-10 lg:py-24"
    >
      <div className="mx-auto max-w-[1440px]">
        <div className="grid items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20">
          <div className="max-w-xl">
            <div className="mb-4 flex items-center gap-2">
              <YoutubeOutlined className="text-[#00B86B]" />

              <span className="text-xs font-semibold uppercase tracking-wider text-[#00A862]">
                YouTube Integration
              </span>
            </div>
            <h2 className="text-3xl font-bold leading-tight tracking-tight text-[#1D1F5D] sm:text-4xl">
              How KGS Studio connects to YouTube
            </h2>

            <p className="mt-2 text-base leading-7 text-[#64748B]">
              KGS Studio connects to authorized users&apos; YouTube accounts
              using Google&apos;s OAuth authentication and YouTube&apos;s
              official APIs. With authorization, KGS Studio can provide
              features such as uploading and scheduling videos and managing
              live broadcasts on the user&apos;s authorized YouTube channel.
            </p>
            <Link
              to="/privacy-policy"
              className="mt-7 inline-flex active:scale-95 items-center gap-2 rounded-lg border border-[#D9DCE5] bg-white px-4 py-2.5 text-sm font-semibold text-[#172033] no-underline shadow-sm transition-all duration-200 hover:border-[#00B86B]/40 hover:bg-[#F7F8FC] hover:text-[#1D1F5D]"
            >
              Read the full explanation
          
            </Link>
          </div>
          <div className="flex flex-col gap-3">
            {authorizationPoints.map((point) => (
              <div
                key={point.text}
                className="group flex items-start gap-3 rounded-xl border border-[#E2E5ED] bg-white px-4 py-4 shadow-[0_3px_12px_rgba(29,31,93,0.04)] transition-all duration-200 hover:-translate-y-0.5 hover:border-[#00B86B]/30 hover:shadow-[0_8px_20px_rgba(29,31,93,0.07)] sm:px-5"
              >
                <div className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full text-[#00B86B]">
                  <CheckCircleOutlined className="text-[17px]" />
                </div>
                <p className="m-0 text-sm leading-6 text-[#64748B]">
                  {point.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default YoutubeIntegration;